import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_Loops_for_of() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">🔁 JavaScript for...of Loop</h1>

      {/* Explanation */}
      <div className="tutorial-section">
        <h2 className="section-title">💡 What is a for...of loop?</h2>
        <p>
          The <code className="highlight_code ">for...of</code> loop iterates
          over <b>iterable objects</b> such as arrays, strings, maps, and sets.
          It allows accessing <b>values directly</b> without dealing with
          indices.
        </p>
        <div
          style={{
            background: "linear-gradient(135deg, #fef3c7, #fde68a)",
            padding: "1rem",
            borderRadius: "12px",
            marginTop: "2rem",
            paddingLeft: "35px",
          }}
        >
          <h3 style={{ color: "#92400e" }}>🛠 How it works:</h3>
          <ol className="tutorial-list-points">
            <li>
              <b>Loop Variable:</b> Declare a variable that represents each
              value in the iterable, e.g.,{" "}
              <code className="highlight_code ">item</code>.
            </li>
            <li>
              <b>Iteration:</b> JavaScript automatically iterates through each
              value in the iterable.
            </li>
            <li>
              <b>Code Block:</b> Access the value directly using the loop
              variable.
            </li>
          </ol>
        </div>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Iterating an Array</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let courses = ["JavaScript", "React", "Node"];
for (let course of courses) {
  console.log("Course at Edu-Tech Master Academy:", course);
}`}
          />
          <TryItButton
            code={`let courses = ["JavaScript", "React", "Node"];
for (let course of courses) {
  console.log("Course at Edu-Tech Master Academy:", course);
}`}
          />
        </div>
        <OutputBox>
          <pre>
            Course at Edu-Tech Master Academy: JavaScript{"\n"}
            Course at Edu-Tech Master Academy: React{"\n"}
            Course at Edu-Tech Master Academy: Node
          </pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Iterating a String</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let name = "Edu-Tech";
for (let char of name) {
  console.log(char);
}`}
          />
          <TryItButton
            code={`let name = "Edu-Tech";
for (let char of name) {
  console.log(char);
}`}
          />
        </div>
        <OutputBox>
          <pre>
            E{"\n"}d{"\n"}u{"\n"}-{"\n"}T{"\n"}e{"\n"}c{"\n"}h
          </pre>
        </OutputBox>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#1e40af" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Compare <code className="highlight_code ">for...of</code> vs{" "}
            <code className="highlight_code ">for...in</code>.
          </li>
          <li>
            Use <code className="highlight_code ">for...of</code> for arrays,
            strings, sets, and maps.
          </li>
          <li>Combine with functions for dynamic iteration.</li>
        </ul>
      </div>
    </div>
  );
}
